/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class BillingModule
 */
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import { BillingReportData } from '@/modules/backend/Billing/BillingReportData';
import homeSmartApi from '@/plugins/HomeSmartApi';
import { BillingPeriod } from '@/modules/backend/Billing/BillingPeriod';

@Module({ store, namespaced: true, name: 'dashboard/billing' })
export class BillingModule extends VuexModule {
  public get report(): BillingPeriod | undefined {
    return this.item;
  }

  private item?: BillingPeriod = undefined;

  @Action
  public async fetchReport(query: BillingReportData): Promise<BillingPeriod | undefined> {
    const report = await homeSmartApi.Billing.report(query);
    this.context.commit('set', report);
    return report;
  }

  @Mutation
  private set(report: BillingPeriod): void {
    this.item = report;
  }
}
